import React from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';
import { Tab, Tabs } from 'react-toolbox';
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu';

import { ecommStatusList } from '~/actions/orders';
import Spinner from '~/components/Spinner';
import Dialog from '~/components/Dialog';

import OrderView from './orderView';
import BatchPrintView from './batchPrintView';
import OrderSearchView from './orderSearchView';

import Styles from './order.scss';

const orderByStates = [
  { value: '-orderDate', label: 'Created (asc)' },
  { value: '-createdAt', label: 'Added (asc)' },
  { value: '-updated', label: 'Updated (asc)' },
  { value: 'orderDate', label: 'Created (desc)' },
  { value: 'createdAt', label: 'Added (desc)' },
  { value: 'updated', label: 'Updated (desc)' }
];

class Orders extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.seekInter = 0;
    this.state = {
      search: '',
      orderBy: 'orderDate',
      curGroup: 2,
      batchPrint: false
    };
  }

  componentDidMount() {
    ecommStatusList(this.props.dispatch, this.context.apiClient);
  }

  setBatchPrintList(list) {
    this.printList = list.join(',').replace(/,(\s+)?$/, '');
  }

  batchPrint() {
    const pdf = `https://migration-api.sherpasystems.net/pdf/batch/${this.printList}`;
    window.open(pdf);
    console.log('Do batch print');
  }

  seek(e) {
    this.setState({ search: e });
  }

  toggleBatchPrint() {
    this.setState({ batchPrint: !this.state.batchPrint });
  }

  render() {
    const listOfGroups = this.props.groups && this.props.groups.toJS();
    if (listOfGroups.length === 0) {
      return (
        <div className={Styles.orderContent}>
          <Spinner />
        </div>
      );
    }
    const tabs = listOfGroups.map(item => {
      let label = item.name;
      if (label === 'Todo') {
        label = 'Processing';
      }
      return (
        <Tab label={label} key={item.name}>
          <OrderView name={item.name} orderBy={this.state.orderBy} />
        </Tab>
      );
    });

    const printTabs = listOfGroups.map(item => {
      let label = item.name;
      if (label === 'Todo') {
        label = 'Processing';
      }
      return (
        <Tab label={label} key={item.name}>
          <BatchPrintView
            setBatchPrintList={list => this.setBatchPrintList(list)}
            name={item.name}
            orderBy={this.state.orderBy}
          />
        </Tab>
      );
    });

    const actions = [
      {
        label: 'Print',
        onClick: () => {
          this.batchPrint();
        }
      }
    ];
    return (
      <div className={Styles.orderContent}>
        <Dialog
          actions={actions}
          active={this.state.batchPrint}
          onEscKeyDown={() => this.toggleBatchPrint()}
          onOverlayClick={() => this.toggleBatchPrint()}
          onCloseButtonClick={() => this.toggleBatchPrint()}
        >
          <Tabs index={this.state.curGroup} onChange={curGroup => this.setState({ curGroup })}>
            {printTabs}
          </Tabs>
        </Dialog>
        <div className={Styles.actionBar}>
          <div className={Styles.searchBox}>
            <Input
              type="text"
              label="Search"
              icon="search"
              value={this.state.search}
              onChange={e => this.seek(e)}
            />
          </div>
          <div className={Styles.orderByBox}>
            <div className="pullLeft" style={{ width: '90%' }}>
              <Dropdown
                label="Order by"
                auto
                onChange={orderBy => this.setState({ orderBy })}
                source={orderByStates}
                value={this.state.orderBy}
              />
            </div>
            <div className="pullRight" style={{ width: '10%', marginTop: '18px' }}>
              <IconMenu icon="more_vert" position="topRight" menuRipple>
                <MenuItem
                  value="print"
                  icon="print"
                  caption="Batch print"
                  onClick={() => this.toggleBatchPrint()}
                />
              </IconMenu>
            </div>
          </div>
        </div>
        <OrderSearchView query={this.state.search} orderBy={this.state.orderBy} />
        <div>
          <Tabs index={this.state.curGroup} onChange={curGroup => this.setState({ curGroup })}>
            {tabs}
          </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  groups: state.getIn(['orders', 'ecommStatusList', 'groupList'], [])
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(Orders);



// WEBPACK FOOTER //
// ./app/pages/Orders/index.js